import { translate } from "app/filters/i18nFilter";

import { StyledSubtitleWrapper } from "../../Shared/SectionTitle/styles";
import { SectionTitle } from "../GeneralSettings/styles";
import { PrimaryBtnText } from "../SettingsActions/styles";

import { deleteSetKeys } from "./automationKeys";
import * as SC from "./styles";
import { deleteSetTexts } from "./texts";

type DeleteSetSchema = {
    onClick: () => void;
    isViewerMode: boolean;
};

const DeleteSet = ({ onClick, isViewerMode }: DeleteSetSchema) => (
    <SC.DeleteWrapper data-automation={deleteSetKeys.wrapper}>
        <SectionTitle>{translate(deleteSetTexts.title)}</SectionTitle>
        <SC.StyledFlexRow>
            <SC.TextWrapper>
                <StyledSubtitleWrapper data-automation={deleteSetKeys.subTitle}>
                    {translate(deleteSetTexts.body)}
                </StyledSubtitleWrapper>
            </SC.TextWrapper>

            <SC.StyledButton
                type="outlined"
                onClick={onClick}
                isDisabled={isViewerMode}
            >
                <PrimaryBtnText>{translate(deleteSetTexts.buttonText)}</PrimaryBtnText>
            </SC.StyledButton>
        </SC.StyledFlexRow>
    </SC.DeleteWrapper>
);

export default DeleteSet;
